import { call, put } from 'redux-saga/effects';

import api from 'api';
import { IUserProfileResponse } from 'api/components/User/types';

import { updateUserSuccess } from '../../user/actions';
import { finalizeSetupFinished } from '../actions';

export function* finalizeSetup() {
    try {
        yield call(api.personalPlan.finalizeSetup);

        yield put(updateUserSuccess({ is_plan_generated: true } as IUserProfileResponse));
    } catch (error) {
        console.error('Finalize Setup Error', error);
    } finally {
        yield put(finalizeSetupFinished());
    }
}
